import { createRequest } from "../tools";

export const salesforceStore = async (data) => {
    return await createRequest({
        suffix: `lead/service/salesforce/store`,
        method: "post",
        payload: data,
    });
};

export const salesforceConnect = async (destination_id, data) => {
    return await createRequest({
        suffix: `lead/service/salesforce/${destination_id}/connect`,
        method: "post",
        payload: data,
    });
};

export const getLeadSalesforceAuthUrl = async (destinationServiceId) => {
    return await createRequest({
        suffix: `lead/service/salesforce/${destinationServiceId}/auth-url`,
        method: "get",
    });
};

export const reconnectLeadSalesforceDestination = async (
    destinationServiceId,
    payload,
) => {
    return await createRequest({
        suffix: `lead/service/salesforce/${destinationServiceId}/reconnect`,
        method: "post",
        payload,
    });
};
